// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"378":"e30f61b9","560":"b4710272","734":"f1fcf1f2","868":"7c70f071"}[chunkId] + ".chunk.css";
};